export type FileTransferDisposition = 'download' | 'openInNewTab';

type FileTransferOptions = {
  disposition?: FileTransferDisposition;
};

export const downloadFromUrl = (
  path: string,
  filename: string,
  options?: FileTransferOptions
) => {
  const anchor = document.createElement('a');
  anchor.href = path;

  if (options?.disposition === 'openInNewTab') {
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
  } else {
    anchor.download = filename;
  }

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export const downloadBlob = (
  blob: Blob,
  filename: string,
  options?: FileTransferOptions
) => {
  const objectUrl = URL.createObjectURL(blob);

  try {
    downloadFromUrl(objectUrl, filename, options);
  } finally {
    globalThis.setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
    }, 1000);
  }
};

export const downloadFileFromUrl = async (
  path: string,
  filename: string,
  init?: RequestInit,
  options?: FileTransferOptions
) => {
  const response = await fetch(path, init);

  if (!response.ok) {
    throw new Error(
      `Failed to download file (${response.status}${response.statusText ? ` ${response.statusText}` : ''})`
    );
  }

  const blob = await response.blob();
  downloadBlob(blob, filename, options);
};
